import { HTMLAttributes, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

export type ICardContainerProps = HTMLAttributes<HTMLDivElement>;

export function CardContainer({
  children,
  className,
  ...rest
}: PropsWithChildren<ICardContainerProps>) {
  return (
    <div className={twMerge('bg-white shadow rounded', className)} {...rest}>
      {children}
    </div>
  );
}
